import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "src/app/guards/auth.guard";
import { AccountComponent } from "./account.component";

const routes: Routes = [
    { 
      path: '',
      component: AccountComponent,
      canActivate: [AuthGuard],
      children: [
        {
          path: 'account',
          data: {
          breadcrumb: 'account'
          },
          component: AccountComponent,
          canActivate: [AuthGuard]
        }
      ]
    }
];
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
export class AccountRoutingModule {}